import {bettingTypes} from "features/core/definitions";

const FOB_TYPE_ORDER = [1881, 1886, 1887, 1888, 1893, 1884, 1885, 1891, 1892];

const fobTypeRank = (bt: any) => {
    const index = FOB_TYPE_ORDER.indexOf(Number(bt.id));
    return index === -1 ? FOB_TYPE_ORDER.length : index;
};

/** Katalogdan seçilebilir FOB türleri (4nala: `bettingTypes.filter(isFob && isSelectable)`). */
export const selectableFobBettingTypes = () =>
    bettingTypes
        .filter((bt: any) => bt.isFob && bt.isSelectable)
        .sort((a: any, b: any) => fobTypeRank(a) - fobTypeRank(b));

export const fobBettingTypeLabel = (bt: any) => String(bt?.name ?? "").replace(/ - Sabit ihtimalli$/i, "");

/** Kartın gerçekten açtığı FOB türleri: `wager_details`teki tiplerle kesişim. */
export function availableFobBettingTypesFor(hippodrome: any): any[] {
    const offered = new Set((hippodrome?.wager_details ?? []).map((w: any) => Number(w.type)));
    return selectableFobBettingTypes().filter((bt: any) => offered.has(Number(bt.id)));
}

/** Bir FOB türünün alt türleri (koşu listesi) - karttaki `wager_details` kaydından. */
export function fobBettingSubTypesFor(hippodrome: any, bettingType: any): any[] {
    const wager = (hippodrome?.wager_details ?? []).find((w: any) => Number(w.type) === Number(bettingType?.id));
    const runs: any[] = wager?.runs ?? [];
    return runs.map((no: any) => ({id: Number(no), label: String(no)}));
}

/** FOB sayfasının seçim bağlamı: kullanıcı hangi karta / türe / koşuya / kolona bakıyor. */
export type FobSelection = {
    hippodrome: any;
    bettingType: any;
    bettingSubType: any;
    column: number;
};

/**
 * Biletlerim'deki "Tekrar Oyna" FOB sayfasına gelirken hangi tür/koşunun açılacağını
 * `navigate(url, {state: {fobSelection}})` ile taşır; sayfa ilk kurulumda bunu benimser.
 */
export type FobSelectionPreset = {bettingTypeId: number; runNo: number};
